import React, { useEffect, useState } from 'react';
import LoginForm from './Form/Login/LoginForm';
import SignupForm from './Form/Signup/SignupForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { useAuth } from '../../context/AuthContext';
import ForgotPassword from './Form/ForgotPassword/ForgotPassword';
import ResetPassword from './Form/ResetPassword/ResetPassword';

const AUTH_TYPE = {
  LOGIN: '/se-connecter',
  SIGNUP: '/inscription',
  FORGOT_PASSWORD: '/mot-de-passe-oublie',
  RESET_PASSWORD: '/reinitialiser-mot-de-passe',
};

const Auth = () => {
  const [authType, setAuthType] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSwitchAuthType = () => {
    setAuthType(authType === AUTH_TYPE.LOGIN ? AUTH_TYPE.SIGNUP : AUTH_TYPE.LOGIN);
    navigate(authType === AUTH_TYPE.LOGIN ? AUTH_TYPE.SIGNUP : AUTH_TYPE.LOGIN, { replace: true });
  };

  useEffect(() => {
    if (location.pathname === AUTH_TYPE.LOGIN) {
      setAuthType(AUTH_TYPE.LOGIN);
    }
    if (location.pathname === AUTH_TYPE.SIGNUP) {
      setAuthType(AUTH_TYPE.SIGNUP);
    }
    if (location.pathname === AUTH_TYPE.FORGOT_PASSWORD) {
      setAuthType(AUTH_TYPE.FORGOT_PASSWORD);
    }
    if (location.pathname === AUTH_TYPE.RESET_PASSWORD) {
      setAuthType(AUTH_TYPE.RESET_PASSWORD);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  return (
    <div className="flex flex-row h-screen w-screen overflow-hidden">
      <div className="bg-primary flex flex-col justify-center items-center w-1/2 h-full gap-10 relative">
        <div className="-z-10 absolute top-0 left-0 w-full h-full opacity-10">
          <div className="w-full h-full bg-pattern-dots"></div>
        </div>
        <div className=" flex flex-col items-center">
          <img src="/assets/logo.png" alt="Logo" className="mb-6 max-w-xs w-4/5" />
          <h1 className="text-3xl font-bold text-white text-center mb-4">
            Bienvenue sur Verbatim
          </h1>
          <p className="text-xl font-medium w-4/5 text-white text-center mb-2">
            L'application réservée aux praticiens Lumen Care.
          </p>
          <p className="text-lg font-medium w-4/5 text-white text-center opacity-90 mb-8">
            {authType === AUTH_TYPE.LOGIN
              ? 'Connectez-vous pour accéder à votre espace personnel.'
              : 'Créez votre compte pour commencer à utiliser Verbatim.'}
          </p>
          {/* <button
            className="cursor-pointer bg-white text-primary text-lg font-medium py-3 px-8 rounded-md hover:bg-opacity-90 transition duration-300 shadow-md"
            onClick={handleSwitchAuthType}
          >
            {authType === AUTH_TYPE.LOGIN ? 'Créer un compte' : 'Se connecter'}
          </button> */}
        </div>
      </div>

      <Fade style={{ width: '50%', height: '100%' }}>
        <div className="flex flex-col justify-center items-center w-full h-full bg-gray-50">
          {authType === AUTH_TYPE.LOGIN && (
            <div className="flex flex-col justify-center items-center w-full h-full">
              <LoginForm />
            </div>
          )}

          {authType === AUTH_TYPE.SIGNUP && (
            <div className="flex flex-col justify-center items-center w-full h-full">
              <SignupForm />
            </div>
          )}

          {authType === AUTH_TYPE.FORGOT_PASSWORD && (
            <div className="flex flex-col justify-center items-center w-full h-full">
              <ForgotPassword />
            </div>
          )}

          {authType === AUTH_TYPE.RESET_PASSWORD && (
            <div className="flex flex-col justify-center items-center w-full h-full">
              <ResetPassword />
            </div>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default Auth;
